import { useMutation, useQuery } from "@apollo/client";
import {
  Button,
  Card,
  Drawer,
  Group,
  LoadingOverlay,
  Modal,
  ScrollArea,
  useMantineTheme,
} from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import EditIcon from "@mui/icons-material/Edit";
import { DEL_MANAGER } from "apollo/mutuations";
import { GET_WARE_HOUSE_MANAGERS } from "apollo/queries";
import ActionButton from "components/controls/ActionButtonNew";
import B2bTable from "components/reusable/b2bTable";
import { customLoader } from "components/utilities/loader";
import WarehouseManagerEditModal from "components/WarehouseManager/WarehouseEditModal";
import WarehouseManagerAddModal from "components/WarehouseManager/WarehouseManagerAdd";
import { useEffect, useState } from "react";

const WarehouseManagers = () => {
  const [size, setSize] = useState("10");
  const [opened, setOpened] = useState(false);
  const [openedDelete, setOpenedDelete] = useState(false);
  const [openedEdit, setOpenedEdit] = useState(false);
  const [editId, setEditId] = useState();
  const [deleteID, setDeleteID] = useState(false);
  const [openedDetail, setOpenedDetail] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  //pagination states
  const [activePage, setActivePage] = useState(1);
  const [total, setTotal] = useState(0);

  const { data, loading, refetch } = useQuery(GET_WARE_HOUSE_MANAGERS, {
    variables: {
      first: parseInt(size),
      page: activePage,
      search: searchValue,
      ordered_by: [
        {
          column: "CREATED_AT",
          order: "DESC",
        },
      ],
    },
    onError(error) {
      showNotification({
        color: "red",
        title: "Error",
        message: error?.graphQLErrors?.[0]?.message || "Failed to Get Managers",
      });
    },
  });

  const handlePageSizeChange = (newSize) => {
    setSize(newSize);
    setActivePage(1);
  };
  useEffect(() => {
    if (data) {
      setTotal(data.myWarehouseManagers.paginatorInfo.lastPage);
    }
  }, [data, size]);
  useEffect(() => {
    refetch();
  }, []);
  const [delRetailer] = useMutation(DEL_MANAGER, {
    update(cache, { data: { deleteWarehouseManager } }) {
      cache.updateQuery(
        {
          query: GET_WARE_HOUSE_MANAGERS,
          variables: {
            first: parseInt(size),
            page: activePage,
            search: "",
            ordered_by: [
              {
                column: "CREATED_AT",
                order: "DESC",
              },
            ],
          },
        },
        (data) => {
          if (data.myWarehouseManagers.data.length === 1) {
            setTotal(total - 1);
            setActivePage(activePage - 1);
          } else {
            return {
              myWarehouseManagers: {
                data: [
                  ...data.myWarehouseManagers.data.filter(
                    (supplier) => supplier.id !== deleteRetailer.id,
                  ),
                ],
              },
            };
          }
        },
      );
    },
  });

  const handleDelete = (id) => {
    setOpenedDelete(true);
    setDeleteID(id);
  };

  const deleteRetailer = () => {
    delRetailer({
      variables: { id: deleteID },
      refetchQueries: [
        {
          query: GET_WARE_HOUSE_MANAGERS,
          variables: {
            first: 10,
            page: 1,
            ordered_by: [
              {
                column: "CREATED_AT",
                order: "DESC",
              },
            ],
          },
        },
      ],
      onCompleted(data) {
        setOpenedDelete(false);
        setDeleteID(null);
        showNotification({
          color: "green",
          title: "Success",
          message: "Manager Deleted Successfully",
        });
      },
      onError(error) {
        setOpenedDelete(false);
        setDeleteID(null);
        showNotification({
          color: "red",
          title: "Error",
          message:
            error?.graphQLErrors?.[0]?.message || "Failed to Delete Managers",
        });
      },
    });
  };

  const handleEditRetailer = (id) => {
    setOpenedEdit(true);
    setEditId(id);
  };

  const handleChange = (currentPage) => {
    setActivePage(currentPage);
  };
  const theme = useMantineTheme();
  const handleManageRetailer = (id) => {
    setEditId(id);
    setOpenedDetail(true);
  };
  const headerData = [
    {
      label: "Warehouse",
      key: "warehouse",
      sortable: false,
      searchable: true,
      render: (rowData) => {
        return <span>{rowData.warehouse.name}</span>;
      },
    },
    {
      label: "Name",
      key: "name",
      sortable: false,
      searchable: true,
      render: (rowData) => {
        return <span>{rowData.user?.name}</span>;
      },
    },
    {
      label: "Email",
      key: "email",
      sortable: false,
      searchable: true,
      render: (rowData) => {
        return <span>{rowData.user?.email}</span>;
      },
    },
    {
      label: "Phone",
      key: "phone",
      sortable: false,
      searchable: true,
      render: (rowData) => {
        return <span>{rowData.user?.phone}</span>;
      },
    },
    {
      label: "Actions",
      key: "actions",
      sortable: false,
      searchable: false,
      render: (rowData) => {
        return (
          <>
            <ActionButton
              label="Edit"
              onClick={() => handleEditRetailer(rowData)}
            >
              <EditIcon style={{ fontSize: "1rem" }} />
            </ActionButton>
            {/*
            <Controls.ActionButton
              color="primary"
              title="Delete"
              onClick={() => handleDelete(`${rowData.id}`)}
            >
              <Trash size={17} />
            </Controls.ActionButton>
            */}
          </>
        );
      },
    },
  ];

  const optionsData = {
    actionLabel: "Add Warhouse Manager",
    setAddModal: setOpened,
  };
  const [confirmedSearch, setConfirmedSearch] = useState("");

  const handleManualSearch = (searchTerm) => {
    setSearchValue(searchTerm);
  };
  const clearInput = () => {
    setSearchValue("");
    setConfirmedSearch("");
  };

  return loading ? (
    <LoadingOverlay
      visible={loading}
      color="blue"
      overlayBlur={2}
      loader={customLoader}
    />
  ) : (
    <div style={{ width: "98%", margin: "auto" }}>
      <Drawer
        opened={openedEdit}
        overlayColor={
          theme.colorScheme === "dark"
            ? theme.colors.dark[9]
            : theme.colors.gray[2]
        }
        overlayOpacity={0.55}
        overlayBlur={3}
        title="Editing a Manager"
        padding="xl"
        onClose={() => setOpenedEdit(false)}
        position="bottom"
        size="80%"
      >
        <WarehouseManagerEditModal
          manager={editId}
          setOpenedEdit={setOpenedEdit}
        />
      </Drawer>

      <Modal
        opened={openedDelete}
        onClose={() => setOpenedDelete(false)}
        title="Warning"
        centered
      >
        <p>Are you sure do you want todelete this user?</p>
        <Group position="right">
          <Button onClick={() => deleteRetailer()} color="red">
            Delete
          </Button>
        </Group>
      </Modal>
      <Drawer
        opened={opened}
        onClose={() => setOpened(false)}
        title="Adding a Manager"
        padding="xl"
        size="80%"
        position="bottom"
      >
        <WarehouseManagerAddModal
          total={total}
          setTotal={setTotal}
          activePage={activePage}
          setActivePage={setActivePage}
          setOpened={setOpened}
          size={size}
        />
      </Drawer>

      <Card shadow="sm" p="lg">
        <ScrollArea>
          <B2bTable
            total={total}
            paginatorInfo={data?.myWarehouseManagers?.paginatorInfo}
            activePage={activePage}
            handleChange={handleChange}
            clearInput={clearInput}
            handelSearch={handleManualSearch}
            searchValue={confirmedSearch}
            onSearchChange={setConfirmedSearch}
            header={headerData}
            optionsData={optionsData}
            loading={loading}
            data={data ? data?.myWarehouseManagers.data : []}
            size={size}
            handlePageSizeChange={handlePageSizeChange}
          />
        </ScrollArea>
      </Card>
    </div>
  );
};

export default WarehouseManagers;
